import React, { useEffect, Fragment, useMemo } from "react"
import _, { get } from "lodash"
import { connect } from "react-redux"
import PropTypes from "prop-types"

import ButtonFixedVoice from "../../components/ButtonFixedVoice"
import MyCustomers from "../../components/MyCustomers"
import MyNumbers from "../../components/MyNumbers"
import GeneralViewOrders from "../../components/GeneralViewOrders"
import DefaultTitle from "shared/components/DefaultTitle"
import InactiveProductsEmptyState from "shared/components/InactiveProductsEmptyState"

import styles from "./styles.css"

import {
  getPartnerCircuit,
  getSpecialistOccurrences,
  getStatusAssetsPartner,
  savePartnerDocument
} from "services/state/fixedVoice/action"

import iconFlag from "../../../../assets/svg/fixed_voice_dash_flag.svg"
import iconFlagWhite from "../../../../assets/svg/fixed_voice_dash_flag_white.svg"

export const Dashboard = ({
  history,
  location,
  occurrences,
  circuit,
  document,
  customerData,
  savedDocument,
  error,
  savePartnerDocument,
  getSpecialistOccurrences,
  getPartnerCircuit,
  getStatusAssetsPartner,
  loading
}) => {
  const hasRequests = get(occurrences, "totalRecords", 0) > 0

  const activeCnpj = useMemo(() => {
    if (!customerData || !customerData.documentNumber) return null

    const searchParams = new URLSearchParams(location.search)
    const cnpjFromUrl = searchParams.get("cnpj")

    if (!cnpjFromUrl) return document

    if (customerData.documentNumber === cnpjFromUrl) return cnpjFromUrl

    const isSubsidiary = customerData.subsidiaryList.some(
      (sub) => sub.cnpj === cnpjFromUrl
    )

    return isSubsidiary ? cnpjFromUrl : document
  }, [location.search, document, customerData])

  useEffect(() => {
    if (activeCnpj && activeCnpj !== savedDocument) {
      savePartnerDocument(activeCnpj)
    }
  }, [activeCnpj, savedDocument, savePartnerDocument])

  useEffect(() => {
    if (activeCnpj && activeCnpj === savedDocument) {
      getSpecialistOccurrences()

      if (!circuit && !loading) {
        getPartnerCircuit()
      }

      if (circuit && !loading) {
        getStatusAssetsPartner(activeCnpj)
      }
    }
  }, [
    activeCnpj,
    savedDocument,
    circuit,
    loading,
    getSpecialistOccurrences,
    getPartnerCircuit,
    getStatusAssetsPartner
  ])

  const goToClientDetails = () => {
    history.push("/fixed-voice/client-details")
  }

  const inactiveProducts = JSON.parse(
    window.localStorage.getItem("inactiveProducts")
  )

  if (inactiveProducts) {
    return (
      <Fragment>
        <DefaultTitle>Vox Fixa</DefaultTitle>
        <InactiveProductsEmptyState />
      </Fragment>
    )
  }

  return (
    <div className={`fullHeight ${styles.fixedVoice}`}>
      <div className={styles.header_dash}>
        <div>
          <h1>Voz Fixa</h1>
        </div>
        <div className={styles.buttons}>
          {hasRequests ? (
            <ButtonFixedVoice
              name="Ver ou abrir solicitações ao especialista"
              linkName={"specialist-requests"}
              icon={iconFlagWhite}
              hasBackgroundLink
            />
          ) : (
            <ButtonFixedVoice
              name="Solicitar análise de especialista"
              linkName={"specialist-analysis"}
              icon={iconFlag}
              isLoading={loading}
              isOutline={true}
            />
          )}
        </div>
      </div>
      <GeneralViewOrders />
      <MyNumbers />

      {error && (
        <div className={styles.container_dash}>
          <div className={styles.error_box}>
            Ocorreu um erro ao tentar encontrar o status.
            <span>{_.capitalize(error)}</span>
          </div>
        </div>
      )}

      <div className={styles.container_dash}>
        <div className={`${styles.third_column}`}>
          <MyCustomers redirectClientDetails={goToClientDetails} />
        </div>
      </div>
    </div>
  )
}

Dashboard.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  occurrences: PropTypes.object,
  circuit: PropTypes.string,
  loading: PropTypes.bool,
  document: PropTypes.string,
  customerData: PropTypes.object,
  savedDocument: PropTypes.string,
  error: PropTypes.string,
  getSpecialistOccurrences: PropTypes.func.isRequired,
  getStatusAssetsPartner: PropTypes.func.isRequired,
  getPartnerCircuit: PropTypes.func.isRequired,
  savePartnerDocument: PropTypes.func
}

const mapStateToProps = ({ newOrder, customer, customersFixedVoice }) => ({
  occurrences: newOrder.response,
  circuit: newOrder.circuit,
  loading: newOrder.loading,
  document: customer.data.documentNumber,
  customerData: customer.data,
  savedDocument: newOrder.documentNumber,
  error: customersFixedVoice.errorStatus
})

const mapActionsToProps = {
  getSpecialistOccurrences,
  getStatusAssetsPartner,
  getPartnerCircuit,
  savePartnerDocument
}

export default connect(mapStateToProps, mapActionsToProps)(Dashboard)



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/Pages/Dashboard/index.js